import { createFileRoute } from '@tanstack/react-router'
import { PasswordResetPage } from '@/pages/PasswordResetPage'

const PasswordResetRoute = () => {
  return <PasswordResetPage />
}

export const Route = createFileRoute('/password-reset')({
  component: PasswordResetRoute,
})
